"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugModule = void 0;
var core_1 = require("@dp-instant/core");
var CreateFPSMeterAction_1 = require("../actions/CreateFPSMeterAction");
var inversify_1 = require("inversify");
exports.DebugModule = new inversify_1.ContainerModule(function () {
    core_1.di.bind("fspMeterAction").to(CreateFPSMeterAction_1.CreateFPSMeterAction);
});
//# sourceMappingURL=DebugModule.js.map